export default __webpack_public_path__ + "static/media/list-bullet.cb92933c.svg";